import { BigSymbolFreegamesBonus } from "./BigSymbolFreegames";
//import { BigSymbolFreegamesConfig } from "./BigSymbolFreegamesConfig";
import { BigSymbolFreegamesBonusFactory } from "./BigSymbolFreegamesFactory";
import { BigSymbolFreegamesBonusParams } from "./BigSymbolFreegamesParams";
import { BigSymbolFreeGameBonus_2Screen } from "./BigSymbolFreegame_2Screen";
import { BigSymbolFreegamesCommonConfiguration } from "../../../api";

export class BigSymbolFreegamesBonusFactory_2Screen extends BigSymbolFreegamesBonusFactory
{
	public CreateSpinAndHoldBonus_2Screen(gameName: string, params: BigSymbolFreegamesBonusParams, config: BigSymbolFreegamesCommonConfiguration): BigSymbolFreegamesBonus
	{
		return new BigSymbolFreeGameBonus_2Screen(gameName, params, config);
	}
}